import debounce from './debounce';

export default class Scrollbar {
    constructor() {
        window.addEventListener(
            'resize',
            debounce(() => {
                Scrollbar.setScrollbarWidth(Scrollbar.getScrollbarWidth());
            }, 100)
        );

        window.addEventListener('load', () => {
            Scrollbar.setScrollbarWidth(Scrollbar.getScrollbarWidth());
        });
    }

    static getScrollbarWidth() {
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll';
        outer.style.msOverflowStyle = 'scrollbar';
        document.querySelector('body').appendChild(outer);

        const inner = document.createElement('div');
        outer.appendChild(inner);

        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
        outer.parentNode.removeChild(outer);

        return scrollbarWidth;
    }

    static setScrollbarWidth(size) {
        document.documentElement.style.setProperty('--scrollbar-width', `${size}px`);
    }
}
